import { CONFIG } from '../../../config/mainConfig';

export const calculateBookCosts = (
  freeBooksAllowed: number,
  newbookCost: string,
  discountAmountPerBook: number,
  additionalPageCost: number,
  bookQty: number,
  couponType: string | null,
  discount: number | null
) => {

  let setBookTotalCost, setNetCost, setShippingCost, setBookCost;
  let booksToCharge = parseInt(bookQty as any) - parseInt(String(freeBooksAllowed));
  if (booksToCharge < 1) booksToCharge = 0;

  const extraBooksCost: any = (
    (parseFloat(String(additionalPageCost)) + parseFloat(newbookCost)) *
    booksToCharge
  ).toFixed(2);

  let isPercentageCoupon = couponType === 'percentage';

  if (!discount) {
    setBookTotalCost = extraBooksCost;
    setNetCost =
      booksToCharge >= 1 ? (parseFloat(extraBooksCost) + CONFIG.BILLING.SHIPPING_COST).toFixed(2) : 0.0;
    setShippingCost = booksToCharge >= 1 ? CONFIG.BILLING.SHIPPING_COST : 0.0;

    setBookCost = booksToCharge >= 1 ? 12.95 : 0.0;
  } else if (discount) {
    if (isPercentageCoupon === true) {

      // Check if the total cost with discount is less than the extra book cost
      if (parseFloat(String(discountAmountPerBook)) > parseFloat(extraBooksCost))
        discountAmountPerBook = extraBooksCost;
      setNetCost = (
        parseFloat(extraBooksCost) - parseFloat(String(discountAmountPerBook)) +
        CONFIG.BILLING.SHIPPING_COST
      ).toFixed(2);

      if (parseFloat(setNetCost) < 0) setNetCost = CONFIG.BILLING.SHIPPING_COST.toFixed(2);

      setBookTotalCost = extraBooksCost;
    } else {
      setNetCost = (
        parseFloat(extraBooksCost) +
        CONFIG.BILLING.SHIPPING_COST -
        parseFloat(String(discountAmountPerBook))
      ).toFixed(2);

      if (parseFloat(setNetCost) < 0) {
        setNetCost = 0;
      }

      const finalCost = parseFloat(setNetCost.toString()).toFixed(2);

      // if (discountAmountPerBook >= Number(setNetCost)) {
      //   finalCost = CONFIG.BILLING.SHIPPING_COST.toFixed(2);
      // } else {
      //   finalCost = parseFloat(setNetCost).toFixed(2);
      // }

      setNetCost = finalCost;
      // Check if the total cost with discount is less than the extra book cost
      setBookTotalCost = extraBooksCost;
    }

    // Ensure `setNetCost` does not fall below the shipping cost

    setShippingCost = CONFIG.BILLING.SHIPPING_COST;
    setBookCost = booksToCharge > 0 ? parseFloat(newbookCost).toFixed(2) : 0.0;
  }

  return { setBookTotalCost, setNetCost, setShippingCost, setBookCost };
};